import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateEducation';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class Education extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '毕业时间',
            en: 'Time',
            key: 'graduationTimeShow',
        }, {
            zh: '学校名称',
            en: 'University',
            key: 'schoolName',
            width: 360,
        }, {
            zh: '专业',
            en: 'Major',
            key: 'specialTypeShow',
            width: 200,
        }, {
            zh: '学历',
            en: 'Degree',
            key: 'academicQualification',
            width: 140,
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryEducationBackgroundList,
            data: {
                userId,
                offset: current,
                limit: pageSize,
                type: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { educationBackgroundList = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data: educationBackgroundList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (row) => {
        const { educationBackgroundId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.delEducationBackground,
            data: { educationBackgroundId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: isChinese ? '操作' : 'Operation',
            key: 'operate',
            width: 80,
            render: (text, row) => {
                return (
                    <span>
                        <a onClick={() => this.update(row)}>修改</a>
                        {
                            isChinese ? 
                                <span>
                                    <span className="ant-divider" />
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                             null
                        }
                    </span>
                );
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                schoolNameChinese,
                schoolNameEnglish,
                specialTypeShow,
                specialTypeShowEnglish,
                academicQualification,
                academicQualificationEnglish,
            } = item;
            return {
                index: index + 1,
                ...item,
                schoolName: isChinese ? schoolNameChinese : schoolNameEnglish,
                specialTypeShow: isChinese ? specialTypeShow : specialTypeShowEnglish,
                academicQualification: isChinese ? academicQualification : academicQualificationEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { canEdit && isChinese && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </div>
        );
    }
}

export default Education;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/Education.js